import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10050;
  padding: 20px;
  animation: bankModalFadeIn 0.2s ease;

  @keyframes bankModalFadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ModalContainer = styled.div`
  background: linear-gradient(165deg, #0f1428 0%, #0a0e27 100%);
  border-radius: 14px;
  max-width: ${(p) => (p.$narrow ? '460px' : '700px')};
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow:
    0 24px 64px rgba(0, 0, 0, 0.55),
    0 0 0 1px rgba(242, 146, 5, 0.12);
  animation: bankModalSlideUp 0.28s ease;
  overflow: hidden;

  @keyframes bankModalSlideUp {
    from {
      transform: translateY(16px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const ModalHeader = styled.div`
  padding: 0;
  border-bottom: none;
`;

export const ModalBody = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;
  max-height: calc(90vh - 200px);

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(242, 146, 5, 0.45);
    border-radius: 4px;

    &:hover {
      background: rgba(242, 146, 5, 0.65);
    }
  }
`;

export const ModalFooter = styled.div`
  padding: 16px 24px;
  background: rgba(255, 255, 255, 0.04);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
`;
